import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const thingsToDoCartSlice = createSlice({
  name: "thingsToDoCart",
  initialState,
  reducers: {
    addThingsToDoItem: (state, action) => {
      state.items.push(action.payload);
    },
    clearThingsToDoCart: (state) => {
      state.items = [];
    },
  },
});

export const { addThingsToDoItem, clearThingsToDoCart } = thingsToDoCartSlice.actions;
export default thingsToDoCartSlice.reducer;
